export default {"src":"/pro/_next/static/media/blitz-logo.00a0c29d.svg","height":208,"width":778,"blurWidth":0,"blurHeight":0};